selectIfElseForm = (element) ->
  $element = $ element
  value = $CAM.parseCurrency($element.val()) || 0
  name = $element.data('name')
  $("[data-behaviour=\"if-else-eval\"][data-name=\"#{name}\"]:not([data-type=\"source\"])").each (index, section) ->
    $section = $ section
    evalContent = $section.data('eval')
    $parent = $section.parents('[data-behaviour="if-else-eval"]:not([data-type=\"source\"])')
    try
      check = eval("#{value}#{evalContent}")
    catch
      check = false
    if check && (!$parent.length || $parent.is(':visible'))
      $section.show().find('input,select,textarea').prop('disabled', false)
    else
      $section.hide().find('input,select,textarea').prop('disabled', true)
    if($.isFunction($().material_select))
      $section.find('select').material_select()
    $section.find('[data-behaviour="if-else-eval"][data-type="source"]').each updateIFElseForm

updateIFElseForm = (index, element) ->
  return selectIfElseForm element

init = ->
  $('[data-behaviour="if-else-eval"][data-type="source"]').each updateIFElseForm

  $(document).on 'input change', 'input[data-behaviour="if-else-eval"][data-type="source"]', ->
    selectIfElseForm @

$(document).ready(init)
